module.exports = __webpack_public_path__ + "img/3.e17dfaa7.jpg";